<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Multifactor Authentication</h2>
    </v-flex>
    <v-flex xs12 md6 id="usereditpassword-main">
      <p class="pb-1">MFA provides an additional layer of security to users of Caseblocks by requesting a temporary password during the login process.</p>
      <p class="pb-1">You'll need an Authenticator app installed on your smartphone. We recommend <a href="https://1password.com">1Password</a>, but free options include <a href="https://www.microsoft.com/en-us/account/authenticator">Microsoft Authenticator</a> and <a href="https://support.google.com/accounts/answer/1066447">Google Authenticator</a>.</p>

      <v-form v-if="!user.mfaEnabled">
        <img :src="qrCodeURL" />

        <p class="pb-1">1. Using your chosen authenticator app please scan the QR code above.</p>
        <p class="pb-1">2. Enter the 6-digit code that the authenticator app has generated and hit "Save Changes" to confirm.</p>

        <v-text-field
          type="text"
          :rules="[rules.min]"
          aria-label="usereditpassword-pass-text"
          label="One-time Password"
          v-model="password"
          :placeholder="this.passwordph"
          @change="userUpdated()"
          @keyup="userUpdated()"
          class="pb-3"
          box
        ></v-text-field>
      </v-form>

      <v-form v-else>
        <v-switch
          aria-label="usereditdetails-mfa-switch"
          v-model="mfaEnabled"
          label="MFA Enabled"
          @change="$emit('toggleMFA')"
          color="secondary"
          class="mb-3 mt-0"/>        
      </v-form>
      <!-- <p class="pb-1">
        Note: Some more instructions.... use 1Password.
      </p> -->
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      password: "",
      mfaEnabled: true,
      passwordph: "e.g. 482901",
      rules: {
        min: v => v.length === 6 || "Exactly 6 digits"
      }
    }
  },
  computed: {
    qrCodeURL() {
      const path = `/mfa/mfa_qr_code/`+this.user.id
      const token = window.localStorage.getItem('session')
      const baseURL = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${path}` : path
      return `${baseURL}?token=${token}`      
    },
    ...mapState({
      user: state => state.users.currentlySelected.user
    })
  },
  methods: {
    userUpdated() {
      if (this.password && this.password.length === 6) {
        this.user.totp = this.password
        this.$emit("mfaUpdate")
      }
    }
  }
}
</script>
